import { GET, POST } from "./api.js";

export const logs = {
    saveLog: (data) => POST(`/audit-log/`, data),

}